module.exports = __webpack_public_path__ + "static/img/glasses_02.2f9cd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/glasses_02.png
// module id = 5S7o
// module chunks = 0